/*import { Deferred } from './PromiseUtils.js';

function isPromise(p: any): p is PromiseLike<any> {
    return p && typeof p.then === 'function';
}

function addReject(prom: PromiseLike<any>, reject: (reason: any) => any) {
    prom.then(null, reject); // Use this style for sake of non-Promise thenables (e.g., jQuery Deferred)
}

// States
enum SyncPromiseState {
    PENDING = 2,
    FULFILLED = 0, // We later abuse these as array indices
    REJECTED = 1
}

export class SyncPromise<T> implements Promise<T> {
    private v: any;
    private s: SyncPromiseState;
    private c: any;
    private a: any;

    constructor(executor: (resolve: (value?: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void) {
        this.v = 0; // Value, this will be set to either a resolved value or rejected reason
        this.s = SyncPromiseState.PENDING; // State of the promise
        this.c = [[], []]; // Callbacks c[0] is fulfillment and c[1] contains rejection callbacks
        this.a = false; // Has the promise been resolved synchronously
        var syncResolved = true;

        let transist = (val: any, state: SyncPromiseState) => {
            this.a = syncResolved;
            this.v = val;
            this.s = state;
            if (state === SyncPromiseState.REJECTED && !this.c[state].length) {
                throw val;
            }
            this.c[state].forEach((fn: any) => fn(val));
            this.c = null; // Release memory.
        };

        let resolve = (val: any) => {
            if (!this.c) {
                // Already resolved, do nothing.
            } else if (isPromise(val)) {
                addReject(val.then(resolve), reject);
            } else {
                transist(val, SyncPromiseState.FULFILLED);
            }
        };

        let reject = (reason: any) => {
            if (!this.c) {
                // Already resolved, do nothing.
            } else if (isPromise(reason)) {
                addReject(reason.then(reject), reject);
            } else {
                transist(reason, SyncPromiseState.REJECTED);
            }
        };

        executor(resolve, reject);
        syncResolved = false;
    }

    public then(cb: any, errBack: any) {
        var self = this;
        if (self.a) { // Promise has been resolved synchronously
            throw new Error('Cannot call `then` on synchronously resolved promise');
        }
        return new SyncPromise(function(resolve, reject) {
            var rej = typeof errBack === 'function' ? errBack : reject;

            function settle() {
                try {
                    resolve(cb ? cb(self.v) : self.v);
                } catch (e) {
                    rej(e);
                }
            }

            if (self.s === SyncPromiseState.FULFILLED) {
                settle();
            } else if (self.s === SyncPromiseState.REJECTED) {
                rej(self.v);
            } else {
                self.c[SyncPromiseState.FULFILLED].push(settle);
                self.c[SyncPromiseState.REJECTED].push(rej);
            }
        });
    }

    public catch(cb: any) {
        var self = this;
        if (self.a) { // Promise has been resolved synchronously
            throw new Error('Cannot call `catch` on synchronously resolved promise');
        }
        return new SyncPromise(function(resolve, reject) {
            function settle() {
                try {
                    resolve(cb(self.v));
                } catch (e) {
                    reject(e);
                }
            }

            if (self.s === SyncPromiseState.REJECTED) {
                settle();
            } else if (self.s === SyncPromiseState.FULFILLED) {
                resolve(self.v);
            } else {
                self.c[SyncPromiseState.REJECTED].push(settle);
                self.c[SyncPromiseState.FULFILLED].push(resolve);
            }
        });
    }

    public finally(cb: any) {
        throw new Error("Not implemented");
    }

    public readonly [Symbol.toStringTag]: "Promise";

    public static defer<R>(): Deferred<R> {
        var result: any = {};
        result.promise = new SyncPromise((resolve: any, reject: any) => {
            result.resolve = resolve;
            result.reject = reject;
        });
        return result;
    }

}

/*
SyncPromise.all = function (promises) {
    return new SyncPromise(function (resolve, reject, l) {
        l = promises.length;
        var hasPromises = false;
        promises.forEach(function (p, i) {
            if (isPromise(p)) {
                hasPromises = true;
                addReject(p.then(function (res) {
                    promises[i] = res;
                    --l || resolve(promises);
                }), reject);
            } else {
                --l || (hasPromises ? resolve(promises) : (function () {
                    throw new Error('Must use at least one promise within `SyncPromise.all`');
                }()));
            }
        });
    });
};

SyncPromise.race = function (promises) {
    var resolved = false;
    return new SyncPromise(function (resolve, reject) {
        promises.some(function (p, i) {
            if (isPromise(p)) {
                addReject(p.then(function (res) {
                    if (resolved) {
                        return;
                    }
                    resolve(res);
                    resolved = true;
                }), reject);
            } else {
                throw new Error('Must use promises within `SyncPromise.race`');
            }
        });
    });
};
*/
